import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IdleService {
  private idleTimeout: any;
  private idleTime = 60000; // 1 menit
  private isCurrentlyIdle = false;
  public onIdle$ = new Subject<boolean>();

  constructor(private ngZone: NgZone) {
    this.initListener();
  }

  private initListener() {
    this.ngZone.runOutsideAngular(() => {
      ['mousemove', 'keydown', 'click', 'touchstart'].forEach(event => {
        window.addEventListener(event, () => this.userActive(), { passive: true });
      });
      this.resetTimer();
    });
  }

  private resetTimer() {
    if (this.idleTimeout) {
      clearTimeout(this.idleTimeout);
    }
    this.idleTimeout = setTimeout(() => {
      if (!this.isCurrentlyIdle) {
        this.isCurrentlyIdle = true;
        this.ngZone.run(() => this.onIdle$.next(true)); // masuk idle
      }
    }, this.idleTime);
  }

  private userActive() {
    this.resetTimer();
    if (this.isCurrentlyIdle) {
      this.isCurrentlyIdle = false;
      this.ngZone.run(() => this.onIdle$.next(false)); // kembali aktif hanya jika sebelumnya idle
    }
  }
}
